module.exports = __webpack_public_path__ + "img/logo13.93dd4e8.jpg";